import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  rangeInputContainer: css`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    > div {
      flex: 1;
      max-width: 120px;
    }

    @media (max-width: 360px) {
      flex-direction: column;
      align-items: stretch;

      > div {
        max-width: none;
      }
    }
  `,
  dropdownButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    color: ${theme.colors.neutral.variant[70]};
    width: 90px;
    justify-content: flex-end;

    @media (max-width: 360px) {
      align-self: flex-end;
      width: auto;
    }
  `,
  unitDropdownMenu: css`
    z-index: 3;
  `,
} satisfies Styles<void>;

export const useRangeInputRequirementStyles = withStyles(styles);
